import { PropsWithClassNames } from "../../../structure";
import { Fonts } from "../../../structure/layout/font";

export interface IconProps extends PropsWithClassNames {
  name: IconName;
  color?: string;
  variant?: IconVariant;
  size?: number;
  onPress?: () => void;
  disabled?: boolean;
}

export type IconName =
  | "search"
  | "menu"
  | "home"
  | "check"
  | "check_circle"
  | "visibility"
  | "visibility_off"
  | "info"
  | "error"
  | "warning"
  | "cancel"
  | "check_box"
  | "check_box_outline_blank"
  | "radio_button_checked"
  | "radio_button_unchecked"
  | "arrow_back"
  | "arrow_back_ios"
  | "arrow_forward_ios"
  | "sports_and_outdoors"
  | "sports_soccer"
  | "logout"
  | "analytics"
  | "close"
  | "change_circle"
  | "trophy"
  | "reward_ads"
  | "emoji_events"
  | "keyboard_arrow_down"
  | "keyboard_arrow_up"
  | "navigate_next"
  | "calendar_month"
  | "calendar_today"
  | "edit"
  | "autorenew"
  | "more_vert"
  | "description"
  | "inventory_2"
  | "person"
  | "account_circle"
  | "delete"
  | "send"
  | "document_scanner"
  | "upload_file"
  | "refresh"
  | "close"
  | "groups"
  | "add"
  | "group_add"
  | "sports_soccer"
  | "podiatry"
  | "location_on"
  | "admin_panel_settings"
  | "schedule"
  | "date_range"
  | "fmd_bad"
  | "front_hand"
  | "all_inclusive"
  | "arrow_drop_up"
  | "arrow_drop_down"
  | "sports_baseball"
  | "star";

export type IconVariant = "outlined" | "rounded" | "sharp";

export const IconVariantMap: { [key in IconVariant]: Fonts } = {
  outlined: Fonts.IconsOutline,
  rounded: Fonts.IconsRound,
  sharp: Fonts.IconsSharp,
};
